import {
  DELETE_CLIENT,
  SET_CLIENTS,
  SET_LOADING,
  UPDATE_CLIENT,
} from './actions/clients'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Clients = RepositoryFactory.get('clients')

export default {
  namespaced: true,
  state: {
    clients: [],
    pagination: {},
    loading: false,
  },
  getters: {
    getList: state => org_id =>
      org_id ? state.clients.find(i => i.id === org_id) : state.clients,
    getPagination: state => state.pagination,
    getLoading: state => state.loading,
  },
  actions: {
    fetchClients({ commit }, settings = {}) {
      commit(SET_LOADING, true)
      Clients.getList(settings)
        .then(res => commit(SET_CLIENTS, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
    fetchItem({ commit }, id) {
      commit(SET_LOADING, true)
      Clients.getItem(id)
        .then(res => commit(UPDATE_CLIENT, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
    updateItem({ commit }, { id, data }) {
      commit(SET_LOADING, true)
      Clients.updateItem(id, data)
        .then(res => commit(UPDATE_CLIENT, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
    createItem({ commit }, data) {
      commit(SET_LOADING, true)
      Clients.postItem(data)
        .then(res => commit(UPDATE_CLIENT, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
    deleteTask({ commit }, id) {
      commit(SET_LOADING, true)
      Clients.deleteItem(id)
        .then(() => commit(DELETE_CLIENT, id))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
  },
  mutations: {
    [SET_LOADING](state, flag = false) {
      state.loading = flag
    },
    [SET_CLIENTS](state, data) {
      const { items, _meta } = data

      state.pagination = _meta
      state.clients = items
    },
    [UPDATE_CLIENT](state, data) {
      if (data && data.can_be_client === 1) {
        const index = state.clients.findIndex(f => f.id === data.id)

        if (index >= 0) {
          state.clients.splice(index, 1, data)
        } else {
          state.clients.push(data)
        }
      }
    },
    [DELETE_CLIENT](state, id) {
      state.clients = state.clients.filter(d => d.id !== id)
    },
  },
}
